/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SwitchVoiceRouteVoIPMutationVariables = {};
export type SwitchVoiceRouteVoIPMutationResponse = {
    readonly switchVoip: {
        readonly result: string | null;
    } | null;
};
export type SwitchVoiceRouteVoIPMutation = {
    readonly response: SwitchVoiceRouteVoIPMutationResponse;
    readonly variables: SwitchVoiceRouteVoIPMutationVariables;
};



/*
mutation SwitchVoiceRouteVoIPMutation {
  switchVoip {
    result
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SwitchVoIP",
    "kind": "LinkedField",
    "name": "switchVoip",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SwitchVoiceRouteVoIPMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SwitchVoiceRouteVoIPMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "82c7ff5022023f5f9bf5e637ce58ee59",
    "id": null,
    "metadata": {},
    "name": "SwitchVoiceRouteVoIPMutation",
    "operationKind": "mutation",
    "text": "mutation SwitchVoiceRouteVoIPMutation {\n  switchVoip {\n    result\n  }\n}\n"
  }
};
})();
(node as any).hash = '0e73ffde6ec92992ce6b83cbb2f925f7';
export default node;
